import React, { useEffect, useState } from 'react';
import { PageType } from '../../enums/pageType.enum';
import { ButtonData } from '../../interfaces/buttonData.types';

import { renderExternalLink, renderInternalLink, renderWhenTrue, renderWhenTrueOr } from '../../utils';

import {
  ButtonContainer,
  Container,
  ContentColumn,
  Description,
  Header,
  SliderColumn,
  Subheader,
  SubheaderLabel,
  SubheaderValue,
  InnerContainer,
  SlideItem,
  SlidePhoto,
  HalfBox,
  DotsContainer,
  Dot,
  ActionButton,
  ClassicButton,
} from './productPageHeader.styled';
import { ProductPageHeaderData } from './productPageHeader.types';

export const ProductPageHeader: React.FC<ProductPageHeaderData> = (data: ProductPageHeaderData) => {
  const {
    productImages,
    header,
    subheader,
    productDescription,
    leftButton,
    rightButton,
    currentLanguage,
  } = data;
  const [activeSlide, setActiveSlide] = useState(0);
  const slideCounter = productImages?.length;
  const slideDelay = 3000;

  const changeActiveSlide = () => setActiveSlide((activeSlide + 1) % slideCounter);

  useEffect(() => {
      const interval = setInterval(() => changeActiveSlide(), slideDelay);
      return () => clearInterval(interval);
  }, [changeActiveSlide]);

  
  const renderButton = (buttonData: ButtonData) => {
    const renderLink = renderWhenTrueOr(
      () => renderInternalLink(buttonData.label, buttonData.internalPage, currentLanguage),
      () => renderExternalLink(buttonData.label, buttonData.externalPage)
    );

    return renderLink(buttonData.positionType === PageType.Internal);
  };

  const renderLeftButton = renderWhenTrue(() => (
    <ActionButton>
      {renderButton(leftButton)}
    </ActionButton>
  ));

  const renderRightButton = renderWhenTrue(() => (
    <ClassicButton>
      {renderButton(rightButton)}
    </ClassicButton>
  ));

  const renderSlideItems = renderWhenTrue(() => productImages.map((productImage, index) => (
    <SlideItem active={index === activeSlide}>
      <SlidePhoto src={productImage?.localFile?.url} alt={productImage?.alt_text} />
    </SlideItem>
  )));

  const renderSlidesDots = renderWhenTrue(() => productImages.map((_, index) => (
    <Dot active={index === activeSlide} />
  )));

  return (
    <Container>
      <InnerContainer>
        <SliderColumn>
          <DotsContainer>
            {renderSlidesDots(!!productImages && productImages.length > 1)}
          </DotsContainer>
          {renderSlideItems(!!productImages)}
        </SliderColumn>
        <ContentColumn>
          <Header>{header}</Header>
          <Subheader>
            <SubheaderLabel>{subheader.label}</SubheaderLabel>
            <SubheaderValue>{subheader.value}</SubheaderValue>
          </Subheader>
          <Description>{productDescription}</Description>
          <ButtonContainer>
            {renderLeftButton(leftButton.active)}
            {renderRightButton(rightButton.active)}
          </ButtonContainer>
        </ContentColumn>
      </InnerContainer>
      <HalfBox />
    </Container>
  );
};
